import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { TableSection } from "./_components/TableSection";
import { HeaderTable } from "./_components/HeaderTable";
import { RowTable } from "./_components/RowTable";
import ImageIcon from "@mui/icons-material/Image";
import CollectionsIcon from "@mui/icons-material/Collections";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import Audiotrack from "@mui/icons-material/Audiotrack";
import FrenchFlag from "../../images/flag_france.svg";
import SpanishFlag from "../../images/flag_spain.svg";
import GermanFlag from "../../images/flag_germany.svg";
import ItalianFlag from "../../images/flag_italy.svg";
import PortugueseFlag from "../../images/flag_portugal.svg";
import ChineseFlag from "../../images/flag_china.svg";
import JapeneseFlag from "../../images/flag_japan.svg";
import UKFlag from "../../images/flag_uk.svg";
import styled from "@emotion/styled";
import { IconLabel } from "_components/IconLabel";

const Container = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const Pro = () => {
  return (
    <div style={styles.screen}>
      <div style={styles.tab}>
        <TableContainer style={styles.tabContainer} component={Paper}>
          <Table aria-label="customized table">
            <HeaderTable />

            <TableBody>
              <TableSection>Parcours </TableSection>

              {/* Parcours*/}
              <RowTable values={["50", "Illimité"]}>
                Nombre de balise maximum par parcours
              </RowTable>

              <RowTable
                values={[
                  "Découverte ou orientation",
                  "Découverte ou orientation",
                ]}
              >
                Type de parcours
              </RowTable>

              <RowTable values={["Privé ou public", "Privé ou public"]}>
                Accessibilité du parcours
              </RowTable>
              <RowTable
                values={[
                  <ClearIcon style={{ color: "gray" }} />,
                  <CheckIcon style={{ color: "rgba(230, 100, 0, 1)" }} />,
                ]}
              >
                Mise en valeur du parcours sur la carte publique
              </RowTable>
              <RowTable
                values={[
                  <ClearIcon style={{ color: "gray" }} />,
                  <CheckIcon style={{ color: "rgba(230, 100, 0, 1)" }} />,
                ]}
              >
                Balise publique customisable
              </RowTable>
              <RowTable
                values={[
                  <ClearIcon style={{ color: "gray" }} />,
                  <>
                    <CheckIcon style={{ color: "rgba(230, 100, 0, 1)" }} />*
                  </>,
                ]}
              >
                Ajout d'un code pour monétiser le parcours
              </RowTable>

              <RowTable
                values={[
                  <ClearIcon style={{ color: "gray" }} />,
                  <CheckIcon style={{ color: "rgba(230, 100, 0, 1)" }} />,
                ]}
              >
                Calcul et affichage de la distance du parours et du temps estimé
              </RowTable>

              <RowTable
                values={[
                  <ClearIcon style={{ color: "gray" }} />,
                  <div style={styles.flagContainer}>
                    <img
                      style={{ ...styles.flag, ...styles.frenchFlag }}
                      src={FrenchFlag}
                      alt="FrenchFlag"
                    />
                    <img
                      style={{ ...styles.flag, ...styles.ukFlag }}
                      src={UKFlag}
                      alt="UKFlag"
                    />
                    *
                    <img
                      style={{ ...styles.flag, ...styles.ukFlag }}
                      src={GermanFlag}
                      alt="GermanFlag"
                    />
                    *
                    <img
                      style={{ ...styles.flag, ...styles.ukFlag }}
                      src={SpanishFlag}
                      alt="SpanishFlag"
                    />
                    *
                    <img
                      style={{ ...styles.flag, ...styles.ukFlag }}
                      src={ItalianFlag}
                      alt="ItalianFlag"
                    />
                    *
                    <img
                      style={{ ...styles.flag, ...styles.ukFlag }}
                      src={PortugueseFlag}
                      alt="PortugueseFlag"
                    />
                    *
                    <img
                      style={{ ...styles.flag, ...styles.ukFlag }}
                      src={JapeneseFlag}
                      alt="JapeneseFlag"
                    />
                    *
                    <img
                      style={{ ...styles.flag, ...styles.ukFlag }}
                      src={ChineseFlag}
                      alt="ChineseFlag"
                    />
                    *
                  </div>,
                ]}
              >
                Traduction possible
              </RowTable>

              <RowTable
                values={[
                  <ClearIcon style={{ color: "gray" }} />,
                  <CheckIcon style={{ color: "rgba(230, 100, 0, 1)" }} />,
                ]}
              >
                Compteur de participation
              </RowTable>

              {/* Epreuves */}
              <TableSection>Épreuves</TableSection>

              <RowTable
                values={[
                  <CheckIcon style={{ color: "rgba(230, 100, 0, 1)" }} />,
                  <CheckIcon style={{ color: "rgba(230, 100, 0, 1)" }} />,
                ]}
              >
                Ajout d'une épreuve pour valider une balise
              </RowTable>

              <RowTable
                values={[
                  "Réponse textuelle ou QCM",
                  "Réponse textuelle ou QCM",
                ]}
              >
                Format des épreuves
              </RowTable>

              <RowTable
                values={[
                  <ClearIcon style={{ color: "gray" }} />,
                  <CheckIcon style={{ color: "rgba(230, 100, 0, 1)" }} />,
                ]}
              >
                Affichage d'un texte explicatif après validation de l'épreuve
              </RowTable>

              {/* Descriptions */}

              <TableSection>Descriptions</TableSection>
              <RowTable values={[0, "Illimités"]}>
                Nombre de descriptions par balise
              </RowTable>

              <RowTable
                values={[
                  <ClearIcon style={{ color: "gray" }} />,
                  <CheckIcon style={{ color: "rgba(230, 100, 0, 1)" }} />,
                ]}
              >
                Possibilité d'ajouter des liens dans le texte
              </RowTable>
              {/* Multimédia */}
              <TableSection>Multimédia</TableSection>
              <RowTable
                values={[
                  <IconLabel
                    icon=<ImageIcon style={{ color: "rgba(230, 100, 0, 1)" }} />
                  >
                    une image
                  </IconLabel>,
                  <IconLabel
                    icon=<ImageIcon style={{ color: "rgba(230, 100, 0, 1)" }} />
                  >
                    une image
                  </IconLabel>,
                ]}
              >
                Lecture de multimédia sur la fiche du parcours
              </RowTable>
              <RowTable
                values={[
                  <IconLabel
                    icon=<ImageIcon style={{ color: "rgba(230, 100, 0, 1)" }} />
                  >
                    une image
                  </IconLabel>,
                  <Container>
                    <IconLabel
                      style={{ flex: 5 }}
                      icon={
                        <ImageIcon style={{ color: "rgba(230, 100, 0, 1)" }} />
                      }
                    >
                      une image
                    </IconLabel>

                    <IconLabel
                      style={{ flex: 5 }}
                      icon={
                        <SmartDisplayIcon
                          style={{ color: "rgba(230, 100, 0, 1)" }}
                        />
                      }
                    >
                      une vidéo
                    </IconLabel>
                  </Container>,
                ]}
              >
                Lecture de multimédia sur les épreuves
              </RowTable>
              <RowTable
                values={[
                  "0",
                  <Container>
                    <IconLabel
                      reverse={true}
                      style={{ flex: 5 }}
                      icon={
                        <CollectionsIcon
                          style={{ color: "rgba(230, 100, 0, 1)" }}
                        />
                      }
                    >
                      <p>+images</p>
                    </IconLabel>

                    <IconLabel
                      style={{ flex: 5 }}
                      icon={
                        <VideoLibraryIcon
                          style={{ color: "rgba(230, 100, 0, 1)" }}
                        />
                      }
                    >
                      <p>+vidéos*</p>
                    </IconLabel>

                    <IconLabel
                      style={{ flex: 5 }}
                      icon={
                        <Audiotrack style={{ color: "rgba(230, 100, 0, 1)" }} />
                      }
                    >
                      <p>+audios multilangues*</p>
                    </IconLabel>
                  </Container>,
                ]}
              >
                Lecture de multimédia sur les descriptions
              </RowTable>
              <RowTable
                values={[
                  0,
                  <IconLabel
                    icon={
                      <ImageIcon style={{ color: "rgba(230, 100, 0, 1)" }} />
                    }
                  >
                    une image
                  </IconLabel>,
                ]}
              >
                Lecture de multimédia sur l'éxplication de l'épreuve
              </RowTable>

              <RowTable values={["Limitée", "Maximale"]}>
                Qualité des images
              </RowTable>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <p style={styles.ps}>* Module en supplément du tarif de base</p>
    </div>
  );
};

export default Pro;

const styles = {
  tab: {
    justifyContent: "center",
    display: "flex",
  },
  tabContainer: { width: "95%", marginTop: 100, overflow: "visible" },
  screen: {
    marginBottom: 50,
  },
  ps: {
    marginLeft: "2.5%",
    fontWeight: "bold",
  },
  flag: {
    width: 30,
    borderRadius: 15,
    marginLeft: 10,
    flex: 1,
  },
  frenchFlag: {
    marginRight: 10,
  },

  ukFlag: {
    marginLeft: 10,
    marginRight: 3,
  },

  divContainer: {},
};
